/**
 * Insight 模块接口
 * 人群洞察相关
 */

import { get } from '../request';
import type { InsightData } from '../../type/insight-type';

/**
 * 获取人群洞察数据
 * GET /audiences/:audienceKey/insight
 */
export const getAudienceInsight = (audienceKey: string) => {
  return get<InsightData>(`/audiences/${audienceKey}/insight`);
};
